const Cancel = function () {
  this.addItem.modal.hide()
  this.addItem.resetAddItemModal()
}

export default Cancel
